import { Outlet, useLocation } from "react-router-dom";
import FooterSection from "components/newShared/FooterSection";
import { useMemo } from "react";
import { Navbar } from "./navbar/Navbar";
import { FooterBottom } from "./containers/FooterBottom";

export const NewLayout = () => {
  return (
    <>
      <Navbar />
      <Outlet />
      <FooterSection />
      <FooterBottom />
    </>
  );
};
